import { notification } from "antd";
import axios from "axios";
import { publicAPI, privateAPI, attachToken, clientPublicIP } from "../../API";

export const createLog = async (payload) => {
  try {
    attachToken();
    await privateAPI.post(`/logs/create`, payload);
    // console.log("payload", payload);
  } catch (err) {
    console.log("err", err);
  }
};

export const getElectricConsumptionSubChannels = async (payload) => {
  try {
    attachToken();
    // console.log("getElectricConsumptionSubChannels");
    const res = await privateAPI.post(
      `/home/get-electric-consumption-subchannels`,
      payload
    );
    // console.log("getElectricConsumptionSubChannels ", res?.data);
    if (res) {
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
  }
};

export const getElectricConsumption = async () => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.get(`/home/get-electric-consumption`);
    // console.log("getElectricConsumption ", res?.data);
    // const res = await axios.get(
    //   `${clientPublicIP}/dashboard/liveelectricconsumption`,
    //   {
    //     withCredentials: false,
    //     headers: {
    //       "Access-Control-Allow-Origin": "*",
    //     },
    //   }
    // );
    if (res) {
      // console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};
// };

export const getEnergyCost = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.post(`/home/get-energy-cost`, payload);
    if (res) {
      // console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
    // notification.error({
    //   message: err?.response?.data?.message || "Server Error",
    //   duration: 3,
    // });
    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};
// };

export const getElectricConsumptionGraph = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.post(
      `/home/get-total-electric-consumption`,
      payload
    );
    if (res) {
      // console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);

    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};

export const getRoundChartData = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.post(
      `/home/get-round-electric-consumption`,
      payload
    );
    // console.log("getRoundChartData ",res?.data)
    if (res) {
      // console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);

    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};

export const getRoundChartDataSubchannels = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    // console.log("payload ", payload);
    const res = await privateAPI.post(
      `/home/get-round-electric-consumption-subchannels`,
      payload
    );
    if (res) {
      // console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);

    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};
// };

export const getHeatmap = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.post(`/home/get-heat-map`, payload);
    if (res) {
      // console.log("get-heat-map : ", res?.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};
// };

export const getSubChannelHeatmap = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.post(
      `/home/get-heat-map-subchannels`,
      payload
    );
    if (res) {
      console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};

export const getPvProduction = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    const res = await privateAPI.post(`/home/get-pv-production`, payload);
    if (res) {
      // console.log("get-pv-production : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};

export const getPvProductionOnClick = async (payload) => {
  // return async (dispatch) => {
  try {
    attachToken();
    // console.log("getPvProductionOnClick ", payload);
    const res = await privateAPI.post(
      `/home/get-pv-production-consumption`,
      payload
    );
    // console.log("DSds ", res);
    if (res) {
      // console.log("response : ", res.data);
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
    // swal("", err?.response?.data?.message || "Server Error", "error");
  }
};
// };

export const getPowerQualtiy = async () => {
  try {
    attachToken();
    const res = await privateAPI.get(`/home/get-power-qualtiy`);
    if (res) {
      return res.data;
    }
  } catch (err) {
    console.log("err", err);
  }
};
